import React from 'react';
import { Table } from 'antd';

export const CitiesAddedTab = ({ selectedDate }) => {
    const columns = [
        {
            title: 'Schedule',
            dataIndex: 'schedule',
            key: 'schedule',
        },
        {
            title: 'City Name',
            dataIndex: 'cityName',
            key: 'cityName',
        },
        {
            title: 'Date',
            dataIndex: 'date',
            key: 'date',
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
        }
    ];

    return (
        <div className="cities-added-tab">
            <Table 
                columns={columns}
                dataSource={[]}
                pagination={false}
            />
        </div>
    );
}; 